<template>
	<footer class="gw-footer">
		<div class="gw-footer__inner">
			<div class="gw-footer__summary">
				<router-link to="/" class="gw-footer__brand">gb-whatsapp.cc</router-link>
				<p>
					Independent information about GB WhatsApp. We do not develop or maintain the app and are not
					affiliated with WhatsApp or Meta.
				</p>
			</div>

			<nav class="gw-footer__links" aria-label="Footer navigation">
				<router-link to="/privacy-policy/">Privacy Policy</router-link>
				<router-link to="/disclaimer/">Disclaimer</router-link>
				<router-link to="/about-us/">About Us</router-link>
				<router-link to="/contact-us/">Contact Us</router-link>
			</nav>
		</div>
		<div class="gw-footer__legal">
			<p>&copy; 2026 gb-whatsapp.cc. All product names and trademarks belong to their respective owners.</p>
		</div>
	</footer>
</template>

<script>
export default {
	name: 'Footer',
};
</script>

<style lang="scss" scoped>
.gw-footer {
	border-top: 1px solid #dce6e1;
	background: #10241f;
	color: #dfeae6;
	text-align: center;
}

.gw-footer__inner {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
	width: min(1120px, calc(100% - 40px));
	margin: 0 auto;
	padding: 24px 0 16px;
}

.gw-footer__summary {
	max-width: 720px;
	text-align: center;

	p {
		margin: 6px 0 0;
		color: #b7cbc4;
		font-size: 14px;
		line-height: 1.7;
	}
}

.gw-footer__brand {
	color: #fff;
	font-size: 21px;
	font-weight: 800;
}

.gw-footer__links {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	gap: 12px 28px;

	a {
		color: #dfeae6;
		font-size: 14px;
	}

	a:hover,
	a:focus {
		color: #5de0b4;
	}
}

.gw-footer__legal {
	border-top: 1px solid rgba(255, 255, 255, 0.12);

	p {
		width: min(1120px, calc(100% - 40px));
		margin: 0 auto;
		padding: 10px 0 14px;
		color: #9db4ac;
		font-size: 12px;
		line-height: 1.6;
	}
}

@media (max-width: 720px) {
	.gw-footer__inner {
		gap: 14px;
		width: min(100% - 28px, 1120px);
		padding-top: 22px;
		padding-bottom: 68px;
	}

	.gw-footer__links {
		gap: 10px 20px;
	}

	.gw-footer__legal p {
		width: min(100% - 28px, 1120px);
	}
}
</style>
